export enum DataDownloadAggregationType {
  NationalOutputUsable = "NOU",
  FuelOutputUsable = "FOU",
  UnitOutputUsable = "UOU",
}
